import { render } from "./ListadoLugaresFull.vue?vue&type=template&id=774e5e72"
import script from "./ListadoLugaresFull.vue?vue&type=script&lang=js"
export * from "./ListadoLugaresFull.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__